
import { Action } from 'vuex-class';
import { Vue, Component, Watch } from "vue-property-decorator";
import TaLayoutHeader from "@/components/shared/layout/TaLayoutHeader.vue";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import ProgressbarStep from '@/components/shared/ProgressbarStep.vue'
import LayoutFooter from '@/components/shared/layout/FblLayoutFooter.vue';

@Component({ components: { TaLayoutHeader, LayoutLoading,ProgressbarStep,LayoutFooter } })
export default class InsureEmptyRouter extends Vue {
	@Action('setLoading') setLoading;

	progressbarArr = ['身分驗證', '填寫資料', '試算保費', '確認申請']

	// 步驟1~4
	nowStep = 1;

	// 頁面橫幅
	imgRwd: string = 'image_callin_desktop';
	screenWidth: number = 0;

	// 取得畫面寬度
	mounted() {
		this.screenWidth = document.body.clientWidth;
		window.onresize = () => {
			return (() => {
				this.screenWidth = document.body.clientWidth;
			})();
		};
	}

	// 載入橫幅 & 下拉式選單字體大小
	@Watch('screenWidth')
	widthChange() {
		if (this.screenWidth <= 500) {
			this.imgRwd = 'image_callin_mobile';
		} else if (500 < this.screenWidth && this.screenWidth <= 1024) {
			this.imgRwd = 'image_callin_tablet';
		} else {
			this.imgRwd = 'image_callin_desktop';
		}
	}

	@Watch('$route.name', { deep: true })
  onRouterChanged(val) {
	console.log('route change',val)
    this.nowStep = JSON.parse(val.slice(-1));
  }
}
